import { FaExclamationTriangle } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  PUSH_HEALTH,
  getPushHealthMessageKey,
} from "../shared/utils/pushHealth";

/**
 * Persistent / dismissible alert for unhealthy push delivery on this device.
 */
const PushHealthAlert = ({
  status,
  onEnable,
  onOpenSettings,
  onDismiss,
  enableLoading = false,
  className = "",
}) => {
  const { t } = useTranslation();
  const messageKey = getPushHealthMessageKey(status);
  if (!messageKey) return null;

  const showEnable =
    typeof onEnable === "function" &&
    (status === PUSH_HEALTH.NEEDS_PERMISSION ||
      status === PUSH_HEALTH.TOKEN_MISSING);
  const showSettings = typeof onOpenSettings === "function";
  const showDismiss = typeof onDismiss === "function";

  return (
    <div
      className={`mobile-settings-alert mobile-settings-alert-warning ${className}`.trim()}
      role="status"
    >
      <FaExclamationTriangle aria-hidden />
      <div className="mobile-push-health-alert-body">
        <span>{t(messageKey)}</span>
        {(showEnable || showSettings || showDismiss) && (
          <div className="mobile-push-health-alert-actions">
            {showEnable ? (
              <button
                type="button"
                className="mobile-push-health-alert-button"
                disabled={enableLoading}
                onClick={onEnable}
              >
                {t("push.health.enableCta")}
              </button>
            ) : null}
            {showSettings ? (
              <button
                type="button"
                className="mobile-push-health-alert-button"
                onClick={onOpenSettings}
              >
                {t("push.health.openSettings")}
              </button>
            ) : null}
            {showDismiss ? (
              <button
                type="button"
                className="mobile-push-health-alert-dismiss"
                onClick={onDismiss}
              >
                {t("push.health.dismiss")}
              </button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default PushHealthAlert;
